/**
 * Who is told when a chat is gone on the server (KAN-1852).
 *
 * The chat store forgets a deleted chat in one place (``removeChatLocally``),
 * for a delete in this tab and for one announced from elsewhere alike. What
 * lives outside the store and still refers to the chat, such as a file
 * uploaded into it and waiting in a composer, listens here.
 */

type ChatRemovedListener = (chatId: string) => void;

const listeners = new Set<ChatRemovedListener>();

/** Be told about every chat removed from now on. Answers the unsubscribe. */
export function onChatRemoved(listener: ChatRemovedListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** For ``removeChatLocally``: the chat ``chatId`` is gone. */
export function announceChatRemoved(chatId: string): void {
  for (const listener of listeners) listener(chatId);
}
